// extracted by mini-css-extract-plugin
module.exports = {"TagList":"TagList_TagList__Zi8Hn","TagList___row":"TagList_TagList___row__zZOKm","TagList_item":"TagList_TagList_item__lrgF8"};